/* jshint ignore:start */
var $ = jQuery.noConflict();

// Global configuration
var thbConfig = {
  'contentOutSpeed': 250,
  'contentOutEasing': 'easeOutQuad',
  'contentInSpeed': 180,
  'contentInEasing': 'easeOutQuad',
  'preloadDelay': 350,
  'preloadTransition': 350,
  'preloadEasing': 'linear'
};

$(document).ready(function() {
    $('.gallery a').attr('rel', 'gallery').fancybox({
    'openEffect' : 'fade',
    'closeEffect' : 'fade',
    'nextEffect' : 'fade',
    'prevEffect' : 'fade'
  });

    $('a.form.modal').fancybox({
        autoSize    : true,
        fitToView   : false,
        closeClick  : false,
        title       : this.alt,
        scrolling   : 'auto',
        openEffect  : 'fade',
        closeEffect : 'fade'
  });

  var div = document.createElement('div');
  div.setAttribute('style', 'transition:top 1s ease;-webkit-transition:top 1s ease;-moz-transition:top 1s ease;');
  cssTransitionsSupported = !!(div.style.transition || div.style.webkitTransition || div.style.MozTransition);
  delete div;

  if( cssTransitionsSupported )
    jQuery("body").addClass("transitions");
  else
    jQuery("body").addClass("no-transitions");

  // Menu
  $("#main-nav").menu({
    speed: 150,
    hideCallback: function() {
      $(window).trigger("resize");
    }
  });

  //$("#main-nav > ul.menu, #main-nav > div.menu > ul").mobileMenu();

  // Portfolio filter
  filter_items( $("#filterlist"), $("#worklist"), '.item' );
});


// Hovering menu items ============================================================================
function hover_menu_items() {
  var menu_primary = $(".menu > li > a");
  var menu_hover_class = "menu-item-hover";

  menu_primary.each(function(i,e) {
    var parent = $(e).parents("li");

    $(e).mouseover(
      function() {
        parent.addClass(menu_hover_class);
      }
    );
    $(e).mouseout(
      function() {
        parent.removeClass(menu_hover_class);
      }
    );

    var submenu = parent.find("ul");

    submenu.mouseover(
      function() {
        parent.addClass(menu_hover_class);
      }
    );
    submenu.mouseout(
      function() {
        parent.removeClass(menu_hover_class);
      }
    );
  });
}

// Filter =========================================================================================

function filter_items(filterlist, itemscontainer, itemsclass) {

  // Filter selection
  var filtertriggers = filterlist.find("li a");

  // Temporarily hiding the filter
  filterlist
    .css({ visibility: 'hidden', opacity: 0 });

  filtertriggers.each(function() {
    var trigger = $(this),
      href = trigger.attr("href").replace("#", "");

    if( href == 'all' || $(itemsclass + "." + href).length > 0 ) {

      trigger.click(function() {
        filterlist.find("li").removeClass("current");
        trigger.parent().addClass("current");

        // Options
        var options = {};
        if( href != 'all' )
          options.filter = "."+href;
        else
          options.filter = itemsclass;

        // Fire isotope
        // itemscontainer.isotope(options);

        return false;
      });

    }
    else if( href != 'all' )
      trigger.parent().remove();
  });

  // Showing the filter again
  filterlist
    .css({ visibility: 'visible' })
    .delay(1000)
    .animate({ opacity: 1 }, 250);

//   itemscontainer.imagesLoaded(function() {

    // setTimeout(function() {
    //   itemscontainer.isotope({
    //     itemSelector: itemsclass,
    //     layoutMode: 'fitRows',

    //     animationOptions: {
    //       duration: 250,
    //       easing: 'linear',
    //       queue: false
    //     }
    //   });
    // }, 10);
//   });
}


/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 *
 * Open source under the BSD License.
 *
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
$.easing['jswing'] = $.easing['swing'];

$.extend( $.easing,
{
  def: 'easeOutQuad',
  swing: function (x, t, b, c, d) {
    //alert(jQuery.easing.default);
    return $.easing[this.def](x, t, b, c, d);
  },
  easeInQuad: function (x, t, b, c, d) {
    return c*(t/=d)*t + b;
  },
  easeOutQuad: function (x, t, b, c, d) {
    return -c *(t/=d)*(t-2) + b;
  },
  easeInOutQuad: function (x, t, b, c, d) {
    if ((t/=d/2) < 1) return c/2*t*t + b;
    return -c/2 * ((--t)*(t-2) - 1) + b;
  },
  easeInCubic: function (x, t, b, c, d) {
    return c*(t/=d)*t*t + b;
  },
  easeOutCubic: function (x, t, b, c, d) {
    return c*((t=t/d-1)*t*t + 1) + b;
  },
  easeInOutCubic: function (x, t, b, c, d) {
    if ((t/=d/2) < 1) return c/2*t*t*t + b;
    return c/2*((t-=2)*t*t + 2) + b;
  },
  easeInQuart: function (x, t, b, c, d) {
    return c*(t/=d)*t*t*t + b;
  },
  easeOutQuart: function (x, t, b, c, d) {
    return -c * ((t=t/d-1)*t*t*t - 1) + b;
  },
  easeInOutQuart: function (x, t, b, c, d) {
    if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
    return -c/2 * ((t-=2)*t*t*t - 2) + b;
  },
  easeInQuint: function (x, t, b, c, d) {
    return c*(t/=d)*t*t*t*t + b;
  },
  easeOutQuint: function (x, t, b, c, d) {
    return c*((t=t/d-1)*t*t*t*t + 1) + b;
  },
  easeInOutQuint: function (x, t, b, c, d) {
    if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
    return c/2*((t-=2)*t*t*t*t + 2) + b;
  },
  easeInSine: function (x, t, b, c, d) {
    return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
  },
  easeOutSine: function (x, t, b, c, d) {
    return c * Math.sin(t/d * (Math.PI/2)) + b;
  },
  easeInOutSine: function (x, t, b, c, d) {
    return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
  },
  easeInExpo: function (x, t, b, c, d) {
    return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
  },
  easeOutExpo: function (x, t, b, c, d) {
    return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
  },
  easeInOutExpo: function (x, t, b, c, d) {
    if (t==0) return b;
    if (t==d) return b+c;
    if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
    return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
  },
  easeInCirc: function (x, t, b, c, d) {
    return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
  },
  easeOutCirc: function (x, t, b, c, d) {
    return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
  },
  easeInOutCirc: function (x, t, b, c, d) {
    if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
    return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
  },
  easeInElastic: function (x, t, b, c, d) {
    var s=1.70158;var p=0;var a=c;
    if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
    if (a < Math.abs(c)) { a=c; var s=p/4; }
    else var s = p/(2*Math.PI) * Math.asin (c/a);
    return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
  },
  easeOutElastic: function (x, t, b, c, d) {
    var s=1.70158;var p=0;var a=c;
    if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
    if (a < Math.abs(c)) { a=c; var s=p/4; }
    else var s = p/(2*Math.PI) * Math.asin (c/a);
    return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
  },
  easeInOutElastic: function (x, t, b, c, d) {
    var s=1.70158;var p=0;var a=c;
    if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
    if (a < Math.abs(c)) { a=c; var s=p/4; }
    else var s = p/(2*Math.PI) * Math.asin (c/a);
    if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
    return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
  },
  easeInBack: function (x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c*(t/=d)*t*((s+1)*t - s) + b;
  },
  easeOutBack: function (x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
  },
  easeInOutBack: function (x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
    return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
  },
  easeInBounce: function (x, t, b, c, d) {
    return c - $.easing.easeOutBounce (x, d-t, 0, c, d) + b;
  },
  easeOutBounce: function (x, t, b, c, d) {
    if ((t/=d) < (1/2.75)) {
      return c*(7.5625*t*t) + b;
    } else if (t < (2/2.75)) {
      return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
    } else if (t < (2.5/2.75)) {
      return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
    } else {
      return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
    }
  },
  easeInOutBounce: function (x, t, b, c, d) {
    if (t < d/2) return $.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
    return $.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
  }
});

/**
 * ****************************************************************************
 * THB add/remove class on hover
 *
 * $(".myelement").hoverClass("classname");
 * ****************************************************************************
 */
(function($) {
  $.fn.hoverClass = function(c) {
    return this.each(function(){
      $(this).hover(
        function() { $(this).addClass(c);  },
        function() { $(this).removeClass(c); }
      );
    });
  };
})(jQuery);

/**
 * ****************************************************************************
 * THB menu
 *
 * $("#menu-container").menu();
 * ****************************************************************************
 */
(function($) {

  $.fn.menu = function(params) {

    // Parameters
    // --------------------------------------------------------------------
    var settings = {
      'speed': 350,
      'easing': 'linear',
      'showCallback': function() {},
      'hideCallback': function() {}
    };

    // Parameters
    $.extend(settings, params);

    // Menu instance
    // --------------------------------------------------------------------
    var instance = {

      showSubMenu: function(subMenu) {
        subMenu
          .stop(true, true)
          .fadeIn(settings.speed, settings.easing, function() {
            settings.showCallback();
          });
      },

      hideSubMenu: function(subMenu) {
        subMenu
          .stop(true, true)
          .fadeOut(settings.speed / 2, settings.easing, function() {
            settings.hideCallback();
          });
      }

    };

    return this.each(function() {
      var menuContainer = $(this),
        menu = menuContainer.find("> ul"),
        menuItems = menu.find("> li"),
        subMenuItems = menuItems.find('li').andSelf();

      menuItems.each(function() {
        $(this)
          .find("> ul")
          .css({
            display: 'none'
          });
      });

      // Binding events
      subMenuItems.each(function() {
        var item = $(this),
          subMenu = item.find("> ul");

        if( subMenu.length ) {
          item
            .mouseenter(function() {
              instance.showSubMenu(subMenu);
            })
            .mouseleave(function() {
              instance.hideSubMenu(subMenu);
            });
        }
      });
    });

  }

})(jQuery);

/**
 * ****************************************************************************
 * THB full background image
 *
 * $.fullBackground();
 * ****************************************************************************
 */
(function($) {

  $.fullBackground = function(parameters) {

    // Parameters
    // --------------------------------------------------------------------
    var p = $.extend({
      speed: 500,
      easing: 'linear',
      backgroundContainerId: 'background_slider',
      slideClass: 'slide',
      slideLoadedClass: 'slide_loaded',
      height: 0,
      offsetHeight: 'center' // 'center', 'top', 'bottom'
    }, parameters);

    // Full background instance
    // --------------------------------------------------------------------
    var instance = {

      // Window dimensions
      w_width: 0,
      w_height: 0,

      // Slides dimensions
      width: 0,
      height: 0,
      offsetTop: 0,
      offsetLeft: 0,

      // Canvas support
      canvas_support: false,

      // Container
      container: $("#" + p.backgroundContainerId),

      // Slides
      slides: $("#" + p.backgroundContainerId).find("." + p.slideClass),

      // Check for canvas support
      checkCanvasSupport: function () {
        var canvas = document.createElement("canvas");
        // instance.canvas_support = !!(canvas.getContext && canvas.getContext('2d'));

        if( instance.canvas_support )
          $("body").addClass("canvas");
      },

      // Window resize
      windowResize: function() {
        setTimeout(function() {
          instance.slides.each(function(i, slide) {
            slide = $(slide);
            instance.slideResize(slide);
          });
        }, 10);
      },

      // Calculate image dimensions
      calculateDimensions: function(imgObj) {
        var w_ratio = instance.w_width / instance.w_height,
          img_height = imgObj.height,
          img_width = imgObj.width,
          img_ratio = img_width / img_height;

        if( w_ratio < img_ratio ) {
          // The window is smaller than the image
          instance.height = instance.w_height;
          instance.width = (instance.w_height/img_height) * img_width;
        } else {
          instance.height = (instance.w_width/img_width) * img_height;
          instance.width = instance.w_width;
        }

        instance.offsetTop = (instance.height - instance.w_height) / -2;
        instance.offsetLeft = (instance.width - instance.w_width) / -2;

        if( p.offsetHeight == 'top' )
          instance.offsetTop = 0;

        if( p.offsetHeight == 'bottom' ) {
          instance.offsetTop = instance.w_height - instance.height;
        }

      },

      // Slide loading
      slideLoad: function(slide) {
        var img = slide.find("img");
        var src = img.attr("src");

        img.attr("src", "");
        img
          .one("load", function() {
            instance.slideRender(slide);
          })
          .attr("src", src)
          .mousedown(function() {
            return false;
          });
      },

      // Slide render
      slideRender: function(slide) {
        var img = slide.find("img"),
          canvas = slide.find("canvas");
        var imgObj = img.get(0);

        instance.calculateDimensions(imgObj);

        var obj = img;
        if( instance.canvas_support )
          obj = canvas;

        if( instance.canvas_support ) {
          var ctx = canvas.get(0).getContext('2d');
          ctx.drawImage(imgObj, instance.offsetLeft, instance.offsetTop, instance.width, instance.height);
        } else {
          var shiftLeft = (instance.width - instance.w_width) / 2 * -1,
            shiftTop = (instance.height - instance.w_height) / 2 * -1;

          if( p.offsetHeight == 'top' ) {
            shiftTop = 0;
          }

          if( p.offsetHeight == 'bottom' ) {
            shiftTop = instance.w_height - instance.height;
          }

          img
            .css({
              height: instance.height,
              width: instance.width,
              "max-width": "none",
              position: "relative",
              left: shiftLeft,
              top: shiftTop
            });
        }

        if( !slide.hasClass(p.slideLoadedClass) ) {
          obj.animate({ opacity: 1 }, p.speed, p.easing, function() {
            slide.addClass(p.slideLoadedClass);
          });
        }
      },

      // Get the slide type
      getSlideType: function(slide) {
        if( slide.hasClass("slide_type_picture") )
          return "picture";
        else if( slide.hasClass("slide_type_video") )
          return "video";
        else
          return "html";
      },

      // Slide resize
      slideResize: function(slide) {

        // Getting the viewport's dimension right on iOS
        instance.w_width = instance.container.width();
        instance.w_height = instance.container.height();

        // Slide type
        var type = instance.getSlideType(slide);

        if( type == "video" ) {

          var iframe = slide.find("iframe");
          var object = slide.find("object");

          if( iframe.length > 0 ) {
            iframe
              .attr({ height: instance.w_height, width: instance.w_width });
          }

          if( object.length > 0 ) {
            object
              .attr({ height: instance.w_height, width: instance.w_width });
          }

        } else {

          if( instance.canvas_support ) {

            var canvas = slide.find("canvas");

            if( canvas.length == 0 ) {
              canvas = $('<canvas class="slide_canvas" height="'+instance.w_height+'" width="'+instance.w_width+'"></canvas>');
              canvas
                .css({ opacity: 0 })
                .appendTo(slide);
            }
            else
              canvas
                .attr({ height: instance.w_height, width: instance.w_width });

          }

        }

        if( !slide.hasClass(p.slideLoadedClass) )
          instance.slideLoad(slide);
        else
          instance.slideRender(slide);

      }

    };

    // Bindings
    // --------------------------------------------------------------------
    $(window)
      .resize(function() {
        instance.windowResize();
      });
    window.onorientationchange = function() {
      instance.windowResize();
    }

    // Boot
    // --------------------------------------------------------------------
    instance.checkCanvasSupport();
    $(window).trigger("resize");

  }

})(jQuery);

/**
 * ****************************************************************************
 * THB toggle
 *
 * $(".toggle").toggle();
 * ****************************************************************************
 */
(function($) {

  $.fn.toggle = function(parameters) {

    var parameters = jQuery.extend( {
      speed: '500',
      easing: 'linear',
      contentClass: 'slide_container',
      activeClass: 'open',
      openedByDefaultClass: 'default_open'
    }, parameters);

    $("."+parameters.contentClass).hide();
    return this.each(function(i,e) {
      var item = $(e);
      item.click(function() {
        $(this)
          .toggleClass(parameters.activeClass)
          .next()
            .toggleClass(parameters.activeClass)
            .slideToggle(parameters.speed, parameters.easing);
        return false;
      });

      if(item.hasClass(parameters.openedByDefaultClass))
        item.trigger("click");
    });

  }

})(jQuery);
